<template>
  <div class="answer-form form">
    <div class="field">
      <label for="text" class="label">Texto *</label>
      <div class="control">
        <input
          type="text"
          class="input"
          v-model="fData.text"
          id="text"
          maxlength="80"
          :disabled="isDisabled || disabledFields.text"
        >
        <div class="is-pulled-right">
          <char-count
            :countdown="80"
            :data-string="fData.text"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>

    <slot name="after-form"></slot>

    <div class="field has-text-centered">
      <slot name="buttons"></slot>
      <button
        class="button is-primary is-large"
        @click="onSubmit(fData)"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
      >
        {{ButtonLabel || "Cadastrar"}}
      </button>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import FormMixin from './FormMixin'
import CharCount from '../CharCount'

export default {
  name: 'AnswerTranslateForm',
  mixins: [FormMixin],
  components: { CharCount },
  data () {
    return {
      fData: {
        text: ''
      }
    }
  },
  validations: {
    fData: {
      text: {
        required,
        maxLength: maxLength(80)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/AnswerTranslateForm.vue